// Client-side auth helpers for marketplace user accounts
// (separate from the business owner auth in useAuth.ts)

const TOKEN_KEY = 'marinelink_user_token';
const USER_KEY = 'marinelink_user';

export interface MarketplaceUser {
  id: number;
  email: string;
  name: string;
  phone?: string | null;
  region?: string | null;
  avatar_url?: string | null;
  verified?: boolean;
  created_at?: string;
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser(): MarketplaceUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as MarketplaceUser;
  } catch {
    return null;
  }
}

export function isLoggedIn(): boolean {
  return !!getToken();
}

export function saveAuth(token: string, user: MarketplaceUser): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function logout(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function authHeaders(): Record<string, string> {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
